import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import { ProductList, Title } from '../../components'
import { greenRectangleStyle } from '../../rectangleStyles'
import { programi } from '../../productInfo'

const Programi = () => (
  <PageTransition>
    <div className="products-title-container">
      <div className="container">
        <Title rectangleStyle={greenRectangleStyle}>Programi</Title>
      </div>
    </div>
    <div className="products-accordion">
      <ProductList products={programi} />
    </div>
  </PageTransition>
)

export default Programi



// WEBPACK FOOTER //
// ./src/pages/proizvodi/programi.js